import React from "react"
import styles from "./AlreadyConfirmedPage.module.scss"
import {TSNWebsiteLink} from "../../features/TSNWebsiteLink/TSNWebsiteLink"
import {AuthHeader} from "../../features/Auth/AuthHeader/AuthHeader"
import {useTranslation} from "react-i18next"
import {Button} from "scholastic-client-components/src/ui/Button/Button"
import {useHistory} from "react-router-dom"
import {useChangeLanguageAPI} from "../../features/ChangeLanguage/useChangeLanguageAPI"
import {useSelector} from "react-redux"
import {changeLanguageSelectors} from "../../slices/changeLanguageSlice"
import {ChangeLanguage} from "../../features/ChangeLanguage/ChangeLanguage"

export const AlreadyConfirmedPage: React.FC = () => {
    const {t} = useTranslation("auth_portal")
    const history = useHistory()

    useChangeLanguageAPI()
    const locales = useSelector(changeLanguageSelectors.getData)?.locales


    return (
        <div className={styles.wrapper}>
            <div className={styles.language}>
                <ChangeLanguage locales={locales} />
            </div>
            <div className={styles.main}>
                <AuthHeader text={t`auth_portal:account_confirmed.already_confirmed`}  mb={1.875} />
                <div className={styles.text}>
                    {t`auth_portal:account_confirmed.already_confirmed_description`}
                </div>
                <div className={styles.backBtn}>
                    <Button
                        primary
                        onClick={() => history.push("/")}
                        width100percent
                    >{t`auth_portal:auth_page.back_to_login_button`}</Button>
                </div>
            </div>
            <div className={styles.spacer} />
            <TSNWebsiteLink />
        </div>
    )
}